import { JsonStorageItem, EStorageTarget } from "utils/browserStorage";
import { IWatchdog } from "utils/watchdog";

export const DEFAULT_LOCATION = "Česká republika";
export const RESULTS_PER_PAGE = 20;

export const currentWatchdogStorageItem = new JsonStorageItem<IWatchdog | null>(
  "search_watchdog",
  EStorageTarget.LOCAL,
);

export enum ESessionSearchKeyTypes {
  SEARCH_MAP_PROPERTIES = "SEARCH_MAP_PROPERTIES",
  LAST_SEARCH = "LAST_SEARCH",
  PREVIOUS_URL = "PREVIOUS_URL",
  PREVIOUS_OFFER_SCROLL_POSITION = "PREVIOUS_OFFER_SCROLL_POSITION",
  OFFERS_MAP_CLICK_PIN = "OFFERS_MAP_CLICK_PIN",
}

export const WATCHDOG_OFFER_LIMIT = 500;
